import Box from '@mui/material/Box';
import { LessonAttempt } from '../models/LessonAttempt';
import LessonService from '../services/LessonService';
import React from 'react';
import Typography from '@mui/material/Typography';

interface LessonAttemptTextProps {
  lessonAttempt: LessonAttempt;
  label: string;
}

export default function LessonAttemptText(props: LessonAttemptTextProps) {
  const attemptTitle = LessonService.getAttemptTitle(props.lessonAttempt);
  return (
    <>
      <Typography variant="body1" display={{ xs: 'none', sm: 'inline' }}>
        {props.label}
      </Typography>

      <Typography variant="body1" display={{ sm: 'inline' }}>
        {' '}
        {attemptTitle}
      </Typography>
    </>
  );
}
